export function stripPhonePrefix(value: string): string {
  return value.replace(/^\+/, '');
}
